import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, tap } from 'rxjs';
import { ITranscriptChunk } from '../models/transcription.models';
import { SavedQuotesService } from './savedQuote.service';

@Injectable()
export class TranscriptService {
  private readonly baseUrl = '/transcripts';

  transcriptCache: Record<string, ITranscriptChunk[]> = {};

  constructor(
    protected http: HttpClient,
    private savedQuotesService: SavedQuotesService
  ) {}

  getTranscriptChunks(transcriptId: string) {
    if (this.transcriptCache[transcriptId]) {
      return of(this.transcriptCache[transcriptId]);
    }

    return this.http
      .get<ITranscriptChunk[]>(
        `${this.baseUrl}/chunks?transcriptId=${transcriptId}`
      )
      .pipe(
        tap((chunks) => {
          this.transcriptCache[transcriptId] = chunks;

          this.savedQuotesService.initializeSavedQuoteIds(
            chunks
              .filter((chunk) => chunk.savedQuote)
              .map((chunk) => chunk.transcriptChunkId)
          );
        })
      );
  }
}
